import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactCodeInput from 'react-code-input';
import intl from 'react-intl-universal';
import Grid from '@material-ui/core/Grid';
import LoginError from './forms/LoginErrorPres';
import Button from 'src/ui/library/Button';

/*const codeConfig = {
  inputStyle: {
    marginRight: '8px',
    MozAppearance: 'textfield',
    width: '66px',
    fontSize: '18px',
    height: '60px',
    paddingLeft: '26px',
    backgroundColor: 'black',
    color: 'white',
    border: '1px solid black',
  },
  inputStyleInvalid: {
    marginRight: '8px',
    MozAppearance: 'textfield',
    width: '66px',
    fontSize: '18px',
    height: '60px',
    paddingLeft: '26px',
    backgroundColor: 'black',
    color: 'white',
    border: '1px solid red',
  },
  isValid: true,
};*/

export default class TwoFactorView extends React.Component {
  state = {
    pinCode: '',
  };

  static propTypes = {
    error: PropTypes.object,
    email: PropTypes.string,
    numberAttempts: PropTypes.number,
    isUserLocked: PropTypes.bool,
  };

  onChange = evt => this.setState({ pinCode: evt });

  onClick = evt => {
    evt.preventDefault();
    const { pinCode } = this.state;
    const { profileKey } = this.props;
    return this.props.onClick(pinCode, profileKey);
  };
  renderResendCodeFragment = () => {
    const { resendCode, resendCodeMessage, email } = this.props;
    return (
      <Fragment>
        <span className="fix-space d-block">{intl.get('login.twoWayMessage', { email })}</span>
        <a className="link" onClick={() => resendCode(email)}>
          Resend Code
        </a>
        {resendCodeMessage ? <div>{resendCodeMessage}</div> : null}
      </Fragment>
    );
  };

  render() {
    const { error, numberAttempts, isUserLocked, validateCodeStatus } = this.props;
    const ref = isUserLocked || validateCodeStatus === 'PENDING';

    return (
      <Fragment>
        <Grid item xs={12}>
          <div className="title">{intl.get('login.twoWayTitle')}</div>
        </Grid>
        <LoginError isUserLocked={isUserLocked} numberAttempts={numberAttempts} error={error} maxAttempts={'third attempt'} />
        <Grid item xs={12} lg={12}>
          {!isUserLocked ? this.renderResendCodeFragment() : null}
        </Grid>
        <Grid item xs={12} lg={12}>
          <div className="note-text">6-Digit Code</div>
          <ReactCodeInput
            autoComplete={'off'}
            type="text"
            fields={6}
            onChange={this.onChange}
            className={`code-input ${error ? 'invalid' : ''}`}
            value="------"
            isValid={error ? false : true}
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <Button onClick={this.onClick} styleType={'login'} disabled={ref}>
            Submit
          </Button>
        </Grid>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/features/Login/presentational/TwoFactorPres.js